import { useGetList } from "ra-core";

export interface OrgMember {
  id: string;
  org_id: string;
  user_id: string;
  role: "owner" | "admin" | "member";
  display_name: string | null;
  email: string | null;
  created_at: string;
}

/**
 * Fetches members of the current org.
 * RLS ensures only members of the user's org are returned.
 */
export function useOrgMembers() {
  return useGetList<OrgMember>("org_members", {
    pagination: { page: 1, perPage: 50 },
    sort: { field: "created_at", order: "ASC" },
  });
}
